import { CLOUDINARY_BASE_URL } from '../../../../constants/cloudinary';

export const getCloudinaryImageSrc = (imageId: string, format = 'auto'): string => {
  const params = [`w_auto`, 'q_auto', `f_${format}`, 'dpr_auto'].join(',');
  return `${CLOUDINARY_BASE_URL}/${params}/${imageId}`;
};
